export function isCurrentAppDetailLoad(
  requestIdentity: string,
  requestGeneration: number,
  activeIdentity: string | null,
  activeGeneration: number,
): boolean {
  return requestIdentity === activeIdentity && requestGeneration === activeGeneration;
}

export function shouldAutoOpenAppActivity(
  active: boolean,
  jobType: string | null | undefined,
  waitingDialog: boolean,
  failedAuthorizationRetry: boolean,
): boolean {
  return (active && jobType !== "template_instance") || waitingDialog || failedAuthorizationRetry;
}
